import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {SettingItem, SettingPopupHtml} from "../../items/index.js";
import {getWidgetName, WIDGET} from "../../widgetConstants.js";

const settingArr = {};

const drawFrameList = async () => {
    const $addWidgetContainer = $('.dashboard-widget-pick-wrap').find('li');
    $addWidgetContainer.html("");
    const {WIDGET_REC: widgetArr} = await DashboardApi.getApi('getSettingWidget',({USE_INTT_ID: _USE_INTT_ID}));
    widgetArr.forEach((item) => {
        settingArr[item.WIDGET_SRNO] = +item.ADDIBLE_COUNT;
        refresh(item);
    })
    $('#widget_setting').css("display", "flex");
}

const openSettingPopup = () => {
    $("#widget_setting").html(SettingPopupHtml());
}

const refresh = (item) => {
    const srno = item.WIDGET_SRNO;
    if(srno === WIDGET.FREQUENT_MEMBER.SRNO && !Mutil.isFunc('FREQUENT_MEMBER_WIDGET')) return false;
    if(srno === WIDGET.WEEKLY_MY_TASK.SRNO && !Mutil.isFunc('WIDGET_WEEKLY_MY_TASK')) return false;

    const $addWidgetContainer = $('.dashboard-widget-pick-wrap').find('ul');
    const isAvailable = settingArr[srno] === 0 || settingArr[srno] - $('#dashboardWrap').find(`li[srno=${srno}]`).length > 0
    $addWidgetContainer.append(`${SettingItem(
        srno, 
        item.WIDGET_ROW,
        getWidgetName(item.WIDGET_SRNO),
        Mutil.n2v(item.USE_INTT_ID) !== "",
        isAvailable
    )}`);
}

export {drawFrameList, settingArr, openSettingPopup}
